<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y get-height"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout align-center row>
      <v-spacer />

      <!-- <router-link :to="{ name: 'nfeImportHistory' }" class="action-bar__link">
        {{ $t(`${namespace}.nfeImportHistory`) }}
      </router-link> -->

      <v-tooltip min-width="160" max-width="160" top>
        <v-btn
          :to="{ name: 'RevenuesNfeImport' }"
          color="accent"
          class="action-bar__btn"
          round
          depressed
          slot="activator"
        >
          {{ $t(`${namespace}.nfeImport`) }}
        </v-btn>
        {{ $t(`${namespace}.nfeImportTooltip`) }}
      </v-tooltip>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      breadcrumbItems: [
        { title: this.$t('Views.FinancialPage.title') },
        { name: 'Revenues', title: this.$t('Views.RevenuesPage.title') }
      ]
    }
  }
}
</script>
